export enum LetterTheme {
  march8 = 'march8',
  february23 = 'february23',
  november4 = 'november4',
  june12 = 'june12',
  may9 = 'may9',
  happyBirthday = 'happyBirthday',
  happyBirthdayVeteran = 'happyBirthdayVeteran',
  happyBirthdayChildrenOfWar = 'happyBirthdayChildrenOfWar',
  happyBirthdayEveryoneOver = 'happyBirthdayToEveryoneOver',
  happyBirthdayBoss = 'happyBirthdayBoss',
  happyBirthdayMemberSVO = 'happyBirthdayMemberSVO',
  happyBirthdayMemberLDPR = 'happyBirthdayMemberLDPR',
  happyBirthday1 = 'happyBirthday1',
  happyBirthday2 = 'happyBirthday2',
  happyBirthday3 = 'happyBirthday3',
  happyBirthday4 = 'happyBirthday4',
  happyNewYear = 'happyNewYear',
}

export enum LetterGroup {
  happyBirthday = 'happyBirthday',
  other = 'other',
}

export enum ReportId {
  general = 'general',
  regions = 'regions',
  detailed = 'detailed',
}

export const GROUPS_OF_LETTERS = [
  {
    name: LetterGroup.other,
    label: 'Разное',
    items: [
      {
        name: LetterTheme.march8,
        label: 'С 8 марта',
        text: `
От всей души поздравляю Вас с Международным женским днём 8 марта!
Ваша поддержка и любовь придают нам сил и уверенности в себе. Спасибо Вам за доброту, щедрость, умение создавать уют и приносить радость в наш мир. В этот день мы с особым удовольствием восхищаемся Вашей красотой, мудростью и терпением. Вы вдохновляете мужчин на великие дела, поддерживаете их в трудные моменты, придаёте им уверенность. Делаете нашу жизнь более возвышенной, спокойной, доброй и счастливой. Именно благодаря Вам такие ценности, как любовь и верность, семья и домашний очаг, остаются вечными и нерушимыми.
Желаю Вам счастья и радости, мира и благополучия!
        `,
      },
      {
        name: LetterTheme.february23,
        label: 'С 23 февраля',
        text: `
Примите мои поздравления с Днём защитника Отечества!
Защита Родины всегда была и остаётся священной обязанностью граждан России. В суровых битвах наши предки, не жалея своих жизней, охраняли границы, отстаивали свободу и независимость нашей страны, оказывали помощь другим народам.
И сегодня Вооружённые силы России, отвага и сила россиян являются фундаментом независимости нашей страны, гарантом мира и безопасности на планете. У России есть надёжные союзники — её армия и флот, и наша задача — заботиться об их укреплении.
От всей души желаю Вам крепкого здоровья, счастья и мирного неба над головой!
        `,
      },
      {
        name: LetterTheme.november4,
        label: 'День народного единства',
        text: `
Поздравляю Вас с праздником - Днём народного единства!
Этот день — символ преемственности поколений, верности традициям, духовной силы и ответственности за судьбу Родины.
Сегодня этот праздник объединяет всех, кто любит и ценит свою страну, кто говорит: «Это моя Россия!» Этот день — символ уважения к государству, к его истории и будущему.
Мы все едины в любви к России — великой стране, где живём мы и будут жить наши дети и внуки. Мы стремимся сделать нашу страну процветающей и благополучной. И только от нас зависит, станет ли она такой.
Я верю, что вместе мы сможем сделать нашу страну лучше, чтобы каждая семья была счастлива и уверена в завтрашнем дне.
От всей души желаю Вам мира и согласия, здоровья, счастья и благополучия!
        `,
      },
      {
        name: LetterTheme.june12,
        label: 'День России',
        text: `
Сердечно поздравляю Вас с государственным праздником – Днем России!
В этот день мы с особой силой ощущаем себя частью великой державы. Испытываем гордость за нашу страну, её богатую историю и культуру. Особенно остро осознаём свою ответственность за настоящее и будущее нашей страны. Ведь оно зависит от каждого из нас — от тех, кто защищает интересы страны в зоне проведения специальной военной операции, от тех, кто трудится на благо Родины и обеспечивает нашим бойцам надёжный тыл.
Пусть, как и прежде, наше единство, сплочённость и верность традициям будут залогом процветания России! Мы гордимся нашей страной и верим в её великое будущее!
Желаю Вам здоровья, тепла и уюта в Вашем доме!
        `,
      },
      {
        name: LetterTheme.may9,
        label: 'День победы',
        text: `
Поздравляю Вас с Днём Великой Победы!
Для граждан нашей страны 9 мая — главный праздник, который объединяет всех нас. Мы всегда будем помнить о тех, кто отдал свою жизнь ради нашего будущего, ради свободы и достоинства людей во всём мире. Память о боевом братстве в борьбе с нацизмом и сегодня объединяет разные поколения россиян, делая нас сильнее перед лицом любых испытаний.
Подвиг тех, кто не вернулся с полей сражений Великой Отечественной войны, навсегда останется в наших сердцах. Для будущих поколений россиян их жизнь - пример патриотизма, доблести и духовного величия. Мы всегда будем помнить о героизме и мужестве, о великой любви к Родине участников Великой Отечественной войны, тружеников тыла.
Желаю Вам мира, согласия, счастья, благополучия и успехов во всех начинаниях на благо нашей Родины!
        `,
      },
      {
        name: LetterTheme.happyNewYear,
        label: 'С новым годом',
        text: `
От всей души поздравляю Вас с Новым годом!
Мы вместе радовались нашим достижениям и успехам, вместе преодолевали трудности. И мы точно знаем, что наш труд не напрасен, самые смелые идеи и грандиозные планы воплощаются в жизнь, делают ее лучше.
Новый год — время ожидания чуда, исполнения надежд. Пусть все хорошее, что было в уходящем году, останется с Вами, а новогодние праздники принесут Вам ещё много радостных моментов в кругу близких людей. Пусть в Вашем доме всегда царят мир и любовь!
От всего сердца желаю Вам счастья, здоровья, оптимизма и благополучия в семье!
С Новым годом, с новым счастьем!
        `,
      },
    ],
  },
  {
    name: LetterGroup.happyBirthday,
    label: 'С днем рождения',
    items: [
      {
        name: LetterTheme.happyBirthdayVeteran,
        label: 'Ветерана',
        text: `
Поздравляю Вас с Днем Рождения!
Вы прошли плечом к плечу со своей страной и своим народом в нелегкие времена. Поколение Победителей мы с гордостью ставим в пример подрастающему поколению.
Ваш подвиг на поле брани Великой Отечественной войны во имя будущего всегда будет жить в благодарных сердцах потомков. Вы подарили нам свободу и возможность развиваться. Для будущих поколений Вы – пример бескорыстной любви к Родине!
Выражаю Вам глубочайшую признательность за Вашу самоотверженность и смелость, за вашу Великую Победу!
Желаю Вам крепкого здоровья, благополучия и мирного неба над головой.
Пусть родные и близкие всегда будут рядом и дарят Вам любовь и заботу!
        `,
      },
      {
        name: LetterTheme.happyBirthdayChildrenOfWar,
        label: 'Дети войны',
        text: `
Поздравляю Вас с Днем Рождения!
Вы — представитель поколения победителей, образец патриотизма, мужества и самоотверженного труда на благо Отечества. Ваш жизненный путь пример для подрастающего поколения.
Годы не властны над Вами, пусть каждый день приносит радость и вдохновение, а время лишь добавляет мудрости и опыта.
С чувством признательности и уважения благодарю Вас за верность долгу, за то что бережете свой дом, храните в нем тепло и уют.
Желаю Вам здоровья, жизненного оптимизма, любви и заботы родных и близких Вам людей!
        `,
      },
      {
        name: LetterTheme.happyBirthdayEveryoneOver,
        label: 'Кому за',
        text: `
От всей души поздравляю Вас с Днём рождения!
Такие люди, как Вы, служат примером для подрастающего поколения, учат мудрости, силе духа и искренней любви к Родине.
Вы — прекрасный человек, и я хочу выразить Вам своё восхищение и уважение за ваш многолетний и добросовестный труд. Ваш путь в профессии — это пример преданности своему делу и стремления приносить пользу нашей великой стране.
От всей души желаю Вам крепкого здоровья, благополучия, поддержки и заботы близких людей.
Желаю Вам уверенности в завтрашнем дне и долгих лет жизни.
Любви, мира Вам и вашему дому!
        `,
      },
      {
        name: LetterTheme.happyBirthday,
        label: 'Общий',
        text: `
Примите самые теплые и искренние пожелания по случаю Вашего дня рождения!
Выражаю Вам свою признательность и уважение за многолетний добросовестный труд. Ваш трудовой путь – свидетельство беззаветного служения своему делу, стремления приносить пользу нашей Великой Родине.
Искренне желаю Вам крепкого здоровья, благополучия, поддержки и внимания близких людей, уверенности в завтрашнем дне и долголетия!
Любви, мира Вам и Вашему дому!
        `,
      },
      {
        name: LetterTheme.happyBirthdayBoss,
        label: 'Руководителя',
        text: `
От всего сердца поздравляю Вас с Днем Рождения!
За годы Вашей плодотворной работы на посту (организации) Вы заслужили непререкаемый авторитет среди коллег.
Вас знают как руководителя, которого отличают ответственность, способность успешно воплощать в жизнь новые идеи и эффективно решать проблемы, а также смелость и оперативность.
Уверен, Ваш профессионализм и компетентность, богатый опыт и активная жизненная позиция и дальше будут способствовать развитию и процветанию нашей великой страны.
Пусть рядом с Вами всегда будут верные друзья и соратники, надёжные помощники, любящие родные и близкие люди!
Желаю Вам крепкого здоровья и дальнейших успехов в Вашей созидательной деятельности!
        `,
      },
      {
        name: LetterTheme.happyBirthdayMemberSVO,
        label: 'Участника СВО',
        text: `
От всего сердца и с огромным уважением поздравляю Вас с Днем Рождения!
Вы — настоящий герой, пример для подражания и источник гордости для всех. Несмотря на все испытания, Вы проявляете невероятное мужество и стойкость, вдохновляя нас своим примером.
Пусть каждый день будет для Вас удачным и светлым. Пусть в Вашей жизни всегда будут любовь, надежда и вера. Мы шлём Вам не только поздравления, но и нашу поддержку, и нашу признательность за Ваш ратный труд!
Желаю Вам крепкого здоровья, неиссякаемой энергии и новых побед на благо нашей великой Родины.
        `,
      },
      {
        name: LetterTheme.happyBirthdayMemberLDPR,
        label: 'Члена ЛДПР',
        text: `
Поздравляю Вас с Днем Рождения!
Ваше участие в работе партии вдохновляет однопартийцев и делает партию еще эффективнее. Важно, что Ваша ежедневная деятельность, направлена на достижение реальных результатов. Благодаря совместным усилиям мы уверенно продвигаемся вперёд, работая на благо людей и поддерживая политический курс, который был определён основателем ЛДПР Владимиром Жириновским.
Уверен, что вместе мы сможем сделать нашу страну лучше, чтобы каждый человек, каждая семья были счастливы и уверены в завтрашнем дне.
Желаю Вам крепкого здоровья, благополучия и бодрости духа!
Пусть родные и близкие всегда будут рядом и дарят любовь и заботу!
        `,
      },
      {
        name: LetterTheme.happyBirthday1,
        label: '1 вариант',
        text: `
Сердечно поздравляю Вас с Днём рождения!
Сегодня особенный день, когда мы все с теплотой вспоминаем Ваши достижения, неиссякаемую энергию и вдохновляющий пример, который Вы подаёте окружающим. Ваш талант, мудрость и доброта делают мир вокруг лучше, а людей рядом с Вами — счастливее и увереннее.
Вы — человек, который не только стремится к высотам, но и помогает другим находить свой путь, вдохновляет своей силой духа и верностью принципам. Пусть этот день станет ещё одним ярким подтверждением того, как Вас ценят, уважают и любят.
От всей души желаю Вам крепкого здоровья, благополучия и мира в душе. Пусть в Вашей жизни всегда будет место для радости, больших свершений и приятных сюрпризов. Пусть родные и близкие окружают Вас любовью и заботой, а коллеги и друзья поддерживают и восхищаются Вами.
Новых свершений, ярких идей, неизменной удачи и вдохновения! Счастья Вам, добра и тепла на долгие годы.
        `,
      },
      {
        name: LetterTheme.happyBirthday2,
        label: '2 вариант',
        text: `
В этот особенный для Вас день примите мои самые теплые и светлые поздравления по случаю Вашего дня рождения!
Каждый день рождения открывает новую страницу в судьбе человека, и каждому предоставляется уникальная возможность реализовать свои самые смелые планы и заветные мечты.
Пусть Ваша жизненная мудрость и целеустремленность помогут Вам принимать верное решение в любой жизненной ситуации. Пусть удача и везение будут верными Вашими спутниками, и жизнь всегда будет полна приятных мгновений, исполняются самые заветные мечты. Хватает времени на семью и на отдых, а между всеми сферами жизни сохраняется идеальный баланс!
Желаю, чтобы Вас всегда окружали родные люди и преданные друзья, готовые поддержать словом и делом. Счастья, благополучия и любви Вам и Вашим близким. Всех земных благ, достатка и благополучия в семье. Пусть Господь всегда оберегает Вас.
        `,
      },
      {
        name: LetterTheme.happyBirthday3,
        label: '3 вариант',
        text: `
В этот особенный для Вас день примите мои самые теплые и светлые поздравления по случаю Вашего дня рождения!
Каждый день рождения открывает новую страницу в судьбе человека, и каждому предоставляется уникальная возможность реализовать свои самые смелые планы и заветные мечты.
Пусть Ваша жизненная мудрость и целеустремленность помогут Вам принимать верное решение в любой жизненной ситуации. Пусть удача и везение будут верными Вашими спутниками, и жизнь всегда будет полна приятных мгновений, исполняются самые заветные мечты. Хватает времени на семью и на отдых, а между всеми сферами жизни сохраняется идеальный баланс!
Желаю, чтобы Вас всегда окружали родные люди и преданные друзья, готовые поддержать словом и делом. Счастья, благополучия и любви Вам и Вашим близким. Всех земных благ, достатка и благополучия в семье. Пусть Господь всегда оберегает Вас.
        `,
      },
      {
        name: LetterTheme.happyBirthday4,
        label: '4 вариант',
        text: `
От всей души поздравляю Вас с Днем рождения.
Желаю вам крепкого здоровья, удачи, новых идей и свершений. Пусть на жизненном пути Вам всегда сопутствует удача, поставленные цели достигаются с неизменным успехом, сегодняшний праздник наполнит сердце положительными эмоциями, а рядом с Вами всегда будет любовь и забота родных и близких людей!
        `,
      },
    ],
  },
]

export enum SupporterType {
  individual = 'individual',
  organization = 'organization',
}

export const OPTIONS_OF_SUPPORTER_TYPE = [
  {
    label: 'Физ. лица',
    value: SupporterType.individual,
  },
  {
    label: 'Юр. лица',
    value: SupporterType.organization,
  },
]
